import React from 'react';
import { Grid } from '@mui/material';
import useStore from '../Store/Store';
import '../CanCare/EditProfile/editProfile.css';

/**
 * TabMenu component for creating tabbed navigation
 *
 * @param {Object} props - Component props
 * @param {Array} props.tabs - Array of tab names
 * @param {string} props.activeTab - Currently active tab
 * @param {Function} props.onTabClick - Function called when tab is clicked
 * @param {Object} props.containerStyle - Additional styles for the container
 * @param {Object} props.tabStyle - Additional styles for individual tabs
 *
 * @example
 * // Basic usage
 * <TabMenu
 *   tabs={['General', 'Diagnoses', 'Allergies']}
 *   activeTab={activeTab}
 *   onTabClick={handleTabClick}
 * />
 *
 * @example
 * // With custom styles
 * <TabMenu
 *   tabs={['Tab 1', 'Tab 2', 'Tab 3']}
 *   activeTab={activeTab}
 *   onTabClick={handleTabClick}
 *   containerStyle={{ marginTop: '20px' }}
 *   tabStyle={{ minWidth: '120px' }}
 * />
 */
const TabMenu = ({ tabs, activeTab, onTabClick, containerStyle = {}, tabStyle = {} }) => {
  const width = useStore((state) => state.screenWidth);
  const isMobile = width <= 768;

  return (
    <Grid
      container
      className="tab-menu"
      style={{
        flexWrap: isMobile ? 'nowrap' : 'wrap',
        overflowX: isMobile ? 'auto' : 'visible',
        marginBlock: '30px',
        ...containerStyle,
      }}
    >
      {tabs.map((item, idx) => (
        <Grid
          key={idx}
          className="tab-menu-item"
          style={{
            background: activeTab === item ? '#f5f5f7' : '#fff',
            borderRadius: '30px',
            paddingInline: '20px',
            paddingBlock: '10px',
            color: 'rgb(81, 77, 77)',
            fontWeight: activeTab === item ? '600' : '500',
            cursor: 'pointer',
            minWidth: isMobile ? '120px' : 'auto',
            marginRight: '10px',
            marginBottom: '10px',
            // boxShadow: activeTab === item ? '0 2px 4px rgba(0,0,0,0.1)' : 'none',
            ...tabStyle,
          }}
          onClick={() => onTabClick(item)}
        >
          {item}
        </Grid>
      ))}
    </Grid>
  );
};

export default TabMenu;
